import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const EmergencyHandlingBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-red-600 text-white">
      {t('component:badge.emergencyHandling')}
    </Badge>
  );
};
